import { observer } from 'mobx-react';
import { Dispatch, SetStateAction } from 'react';
import { T } from '../../../../../../../../Translations';
import clsx from 'clsx';

interface Props {
  displayButtonLabel: string;
  onChange: Dispatch<SetStateAction<string>>;
}

function DisplayButtonLabel({ displayButtonLabel, onChange }: Props) {
  return (
    <div className={`mb-6`}>
      <p className="mb-2 text-sm font-semibold text-gray-800">
        <label htmlFor="displayButtonLabel">
          <T kind="Section Button Text (optional)" />
        </label>
      </p>
      <input
        type="text"
        id="displayButtonLabel"
        autoComplete="off"
        maxLength={255}
        className={clsx(
          'w-full rounded-md border border-solid border-gray-300',
          'text-normal mb-1 px-4 py-2.5 text-gray-700',
        )}
        onChange={(e) => onChange(e.target.value)}
        value={displayButtonLabel}
      />
    </div>
  );
}

export default observer(DisplayButtonLabel);
